// React
import React, { useState, useMemo } from "react";
import Moment from "moment";
// Lodash
import { map, uniqBy } from "lodash";
// PropTypes
import PropTypes from "prop-types";
// Redux
import { connect } from "react-redux";

// Components
import IkTable from "@Components/IkTable";
import Screen from "@Components/Screen";
import TagsTable from "./Components/TagsTable";
import YearMonthTable from "./Components/YearMonthTable";
import TagsGroupTable from "./Components/TagsGroupTable";
import ActionsTable from "./Components/ActionsTable";
import TagsCombosTable from "./Components/TagsCombosTable";
import ChatTagsTable from "@Features/ChatTagsReport/Components/ChatTagsTable";

// Utils
import dataHandler from "@Utils/dataHandler";
import ActionUserCrud from "./Modals/ActionUserCrud";
// Styles
import styles from "./styles.module.css";

const TableActionUser = ({ dispatch, userName, companyName, channels }) => {
	const [filteredItems, setFilteredItems] = useState([]);
	const [filteredCount, setFilteredCount] = useState([]);
	const [filteredPrintData, setFilteredPrintData] = useState([]);
	const [platformfilters, setPlatformfilters] = useState([]);
	const [groupsfilters, setGroupsfilters] = useState([]);
	const [tagsSelected, setTagsSelected] = useState([]);
	const [categoriesSelected, setCategoriesSelected] = useState([]);
	const [startDate, setStartDate] = useState(Moment().format("YYYY-MM-DD"));
	const [endDate, setEndDate] = useState("");
	const [contacts, setContacts] = useState("");
	const [agents, setAgents] = useState([]);
	const [note, setNote] = useState("");
	const [checkAlllData, setCheckAllData] = useState([]);
	const [dateField, setDateField] = useState("chat.closeDate");
	const [showTable, setShowTable] = useState(false);
	const [channelFilters, setChannelFilters] = useState([]);
	const [isOpenModal, setIsOpenModal] = useState(true);
	const [tableValue, setTableValue] = useState({});
	const [seletedFilteres, setSeletedFilteres] = useState("Etiquetas");
	const [appliedFilters, setAppliedFilters] = useState({});
	const [stateValue, setStateValue] = useState("");
	const [orderBy, setOrderBy] = useState("");
	const [orderDirection, setOrderDirection] = useState("");
	const [tabValue, setTabValue] = useState("");
	const [actionsSelected, setActionsSelected] = useState([]);

	const options = [
		// { key: "No trabajadas", text: "No trabajadas", value: "No trabajadas" },
		{ key: "Etiquetas", text: "Etiquetas", value: "Etiquetas" },
		{ key: "Etiquetas Grupo", text: "Etiquetas Grupo", value: "Etiquetas Grupo" },
		{ key: "Etiquetas Combinadas", text: "Etiquetas Combinadas", value: "Etiquetas Combinadas" },
		{ key: "Etiquetas-Notas", text: "Etiquetas Notas", value: "Etiquetas-Notas" },
		{ key: "Año/Mes", text: "Año/Mes", value: "Año/Mes" },
		{ key: "Acciones", text: "Acciones", value: "Acciones" },
	];

	const platforms = useMemo(() => {
		return uniqBy(
			map(channels, (item) => {
				return item.platform;
			}),
			"name"
		);
	}, [channels]);

	// Table handlers
	const handlerData = async (params, printable, findAll, isCheck = false) => {
		const data = await dataHandler({ dispatch, url: "chats", params });
		if (!isCheck && !printable) {
			setFilteredItems(data.items);
			setFilteredCount(data.count);
			setTableValue(data.items);
		}
		if (printable) {
			setFilteredPrintData(data.items);
		}

		if (findAll) {
			setCheckAllData(data.items);
		} else {
			setCheckAllData([]);
		}
	};

	// // Table Handlers
	const handleButtom = (name, item) => {
		switch (name) {
			case "Watch":
				setIsOpenModal(true);
				setTableValue(item);
				break;
			default:
				break;
		}
	};

	const handleFilterData = () => {
		setIsOpenModal(true);
	};

	const renderTopButtons = () => {
		return [
			{
				icon: "filter",
				className: styles.refreshButton,
				onClick: handleFilterData,
				content: Object.keys(appliedFilters).length > 0 ? "Filtrando" : "Filtrar",
				label: Object.keys(appliedFilters).length > 0 ? "Filtrando" : "Filtrar",
			},
		];
	};

	const handleApplyFilters = (filters) => {
		setShowTable(true);
		setAppliedFilters(filters);
		setActionsSelected(filters["action[]?"] || []);
		setIsOpenModal(false);
	};

	return (
		<Screen hasHeader hasSidebar headerTitle={`Reporte General${seletedFilteres ? ` - ${seletedFilteres}` : ""}`}>
			{!showTable && (
				<div className={styles.grid}>
					<IkTable
						data={filteredItems}
						handlerTable={handleButtom}
						totalRows={filteredCount}
						dataHandler={handlerData}
						filteredPrintData={filteredPrintData}
						searcher={{
							searchable: false,
							searchPosition: "flex-start",
							searchDisabled: false,
							filterButton: false,
							width: "40rem",
						}}
						topButtons={renderTopButtons()}
						checkAllData={checkAlllData}
					/>
				</div>
			)}
			{seletedFilteres === "Año/Mes" && showTable && (
				<YearMonthTable
					dispatch={dispatch}
					companyName={companyName}
					userName={userName}
					onOpenFilterModal={handleFilterData}
					appliedFilters={appliedFilters}
				/>
			)}
			{seletedFilteres === "Etiquetas" && showTable && (
				<TagsTable
					dispatch={dispatch}
					companyName={companyName}
					userName={userName}
					onOpenFilterModal={handleFilterData}
					appliedFilters={appliedFilters}
				/>
			)}
			{seletedFilteres === "Etiquetas Grupo" && showTable && (
				<TagsGroupTable
					dispatch={dispatch}
					companyName={companyName}
					userName={userName}
					onOpenFilterModal={handleFilterData}
					appliedFilters={appliedFilters}
				/>
			)}
			{seletedFilteres === "Etiquetas Combinadas" && showTable && (
				<TagsCombosTable
					dispatch={dispatch}
					companyName={companyName}
					userName={userName}
					onOpenFilterModal={handleFilterData}
					appliedFilters={appliedFilters}
				/>
			)}
			{seletedFilteres === "Etiquetas-Notas" && showTable && (
				<ChatTagsTable dispatch={dispatch} onOpenFilterModal={handleFilterData} appliedFilters={appliedFilters} />
			)}
			{seletedFilteres === "Acciones" && showTable && (
				<ActionsTable
					dispatch={dispatch}
					companyName={companyName}
					userName={userName}
					onOpenFilterModal={handleFilterData}
					appliedFilters={appliedFilters}
				/>
			)}
			{isOpenModal && (
				<ActionUserCrud
					companyName={companyName}
					userName={userName}
					tableValue={tableValue}
					onClose={() => {
						setIsOpenModal(false);
					}}
					agents={agents}
					contacts={contacts}
					startDate={startDate}
					endDate={endDate}
					note={note}
					platformfilters={platformfilters}
					groupsfilters={groupsfilters}
					tagsSelected={tagsSelected}
					categoriesSelected={categoriesSelected}
					setAgents={setAgents}
					setContacts={setContacts}
					setStartDate={setStartDate}
					setEndDate={setEndDate}
					setNote={setNote}
					setPlatformfilters={setPlatformfilters}
					setGroupsfilters={setGroupsfilters}
					setTagsSelected={setTagsSelected}
					setCategoriesSelected={setCategoriesSelected}
					seletedFilteres={seletedFilteres}
					options={options}
					setSeletedFilteres={setSeletedFilteres}
					dateField={dateField}
					setDateField={setDateField}
					onApplyFilters={handleApplyFilters}
					platforms={platforms}
					channelFilters={channelFilters}
					setChannelFilters={setChannelFilters}
					tabValue={tabValue}
					setTabValue={setTabValue}
					stateValue={stateValue}
					setStateValue={setStateValue}
					orderBy={orderBy}
					setOrderBy={setOrderBy}
					orderDirection={orderDirection}
					setOrderDirection={setOrderDirection}
					actionsSelected={actionsSelected}
					setActionsSelected={setActionsSelected}
				/>
			)}
		</Screen>
	);
};

function mapStateToProps({ user, company }) {
	return {
		user,
		userName: user.name,
		companyName: company.name,
		channels: company.channels,
	};
}

TableActionUser.propTypes = {
	dispatch: PropTypes.func,
	userName: PropTypes.string,
	companyName: PropTypes.string,
	channels: PropTypes.array,
};

export default connect(mapStateToProps)(TableActionUser);
